import {get, writable} from "svelte/store";
import {actualiza, cargaUno, crea} from "../Api/tipos-de-jornada";

const estadoInicial = {
  cargando: true,
  error: null,
  tipo: null
};

const store = writable(estadoInicial);

export default {
  subscribe: store.subscribe,
  cargar: (id) => {
    const timeout = setTimeout(() => store.update(valor => ({...valor, cargando: true})), 300);

    store.update(() => estadoInicial);

    cargaUno(id)
        .then(tipo => store.update(valor => ({...valor, tipo})))
        .catch(e => store.update(valor => ({...valor, error: e})))
        .finally(() => {
          clearTimeout(timeout);
          store.update(valor => ({...valor, cargando: false}));
        });
  },
  quitaCampo: (campo) => {
    store.update(estado => ({
      ...estado,
      tipo: {
        ...estado.tipo,
        [campo]: undefined
      }
    }));
  },
  actualizaCampo: (campo, valor) => {
    store.update(estado => ({
      ...estado,
      tipo: {
        ...estado.tipo,
        [campo]: valor
      }
    }));
  },
  nuevo: () => {
    store.set({
      cargando: false,
      error: null,
      tipo: {
        descripcion: '',
        nombre: '',
        tipo: '',
        color: '',
        activo: '',
        horas: [],
        duracion: 0
      }
    });
  },
  guarda: () => {
    const tipo = get(store).tipo;

    const promesa = tipo.id ? actualiza(tipo) : crea(tipo);
    return promesa
        .then(tipo => store.update(valor => ({...valor, error: false, tipo})))
        .catch(error => store.update(valor => ({...valor, error})));
  }
}